module.exports = __webpack_public_path__ + "assets/img/icon_swiper_mini_before.82acac3c.svg";